import { Container, Row, Col } from "react-bootstrap";
import Informations from "./Informations.jsx";
import ContactForm from "./ContactForm.jsx";

const ContactCorp = () => {
  return (
    <section id="Contact">
      <div className="contact-overlay" id="contact">
        <Row>
          <Col lg={12} className="mb-5">
            <h1 className="contact-titre">
              <span>BESOIN D’INFORMATIONS ?</span><span>UNE RÉCLAMATION ?</span><span> PARLONS-EN</span>
            </h1>
          </Col>
          <Col lg={8}>
            <ContactForm />
          </Col>
          <Col lg={4}>
            <Informations />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ContactCorp;
